export default __webpack_public_path__ + "static/media/qs_patent.22a6a9d0.svg";